import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsDate,
  IsDefined,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import {
  PropertyCoOwnershipProcedureType,
  PropertyCurrentMarketingMode,
  PropertySaleUrgency,
  PropertySubtype,
} from './property-enums';

export class PropertyApartmentAccessibilityDto {
  @IsOptional()
  @IsNumber()
  floor?: number;

  @IsOptional()
  @IsNumber()
  numberOfFloors?: number;
}

export class PropertyAccessibilityDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => PropertyApartmentAccessibilityDto)
  apartment?: PropertyApartmentAccessibilityDto;

  @IsOptional()
  @IsNumber()
  buildingNumberOfFloors?: number;

  @IsOptional()
  @IsBoolean()
  hasElevator?: boolean;

  @IsOptional()
  @IsBoolean()
  buildingHasElevator?: boolean;

  @IsOptional()
  @IsBoolean()
  pmrCompliance?: boolean;
}

export class PropertyAvailabilityDto {
  @IsOptional()
  @IsBoolean()
  isOccupied?: boolean;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  occupiedUntil?: Date;

  @IsOptional()
  @IsEnum(PropertySaleUrgency)
  saleUrgency?: PropertySaleUrgency;

  @IsOptional()
  @IsBoolean()
  isAlreadyOnSale?: boolean;

  @IsOptional()
  @IsEnum(PropertyCurrentMarketingMode)
  currentMarketingMode?: PropertyCurrentMarketingMode;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  exclusiveMandateEndDate?: Date;
}

export class PropertyTrusteeDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsBoolean()
  isOnline?: boolean;

  @IsOptional()
  @IsBoolean()
  hasOngoingProcedures?: boolean;

  @IsOptional()
  @IsArray()
  @IsEnum(PropertyCoOwnershipProcedureType, { each: true })
  ongoingProcedures?: PropertyCoOwnershipProcedureType[];
}

export class PropertyCoOwnershipDto {
  @IsOptional()
  @IsBoolean()
  isInCoOwnership?: boolean;

  @IsOptional()
  @IsNumber()
  numberOfLots?: number;

  @IsOptional()
  @IsString()
  lotNumber?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => PropertyTrusteeDto)
  trustee?: PropertyTrusteeDto;
}

export class PropertySurfaceDto {
  @IsNumber()
  habitable!: number;

  @IsOptional()
  @IsNumber()
  ground?: number;

  @IsOptional()
  @IsNumber()
  land?: number;
}

export class PropertyKeyInfoDto {
  @IsNotEmpty()
  @IsString()
  subtype!: PropertySubtype;

  @IsDefined()
  @ValidateNested()
  @Type(() => PropertySurfaceDto)
  surface: PropertySurfaceDto = new PropertySurfaceDto();

  @IsOptional()
  @ValidateNested()
  @Type(() => PropertyAvailabilityDto)
  availability?: PropertyAvailabilityDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => PropertyAccessibilityDto)
  accessibility?: PropertyAccessibilityDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => PropertyCoOwnershipDto)
  coOwnership?: PropertyCoOwnershipDto;
}
